<template>
    <div class="wrap-dashboard">
        <div class="main-content">
            <div class="wrap-content">
                <ParticipantPage></ParticipantPage>
            </div>
        </div>
    </div>
</template>
<script>
import ParticipantPage from '../../components/bappebti/page/ParticipantPage.vue';

export default {
    components: {ParticipantPage}
}
</script>